<template>
    <div>
        <Layout>
            <Sider class="sidebar" collapsible :collapsed-width="30" :hide-trigger="true" v-model="isCollapsed" ref="lSider1" @on-collapse="changestate" :style="{background:treeDisp?'#fff':'#fff',borderRight:'1px solid #e8eaec'}">
                <Button type="text" @click="toggle" icon="ios-menu" :style="{
                    width:'100%',
                    borderRadius:'0px',
                    boxShadow:'none',
                    color:'white',
                    background:'#2d8cf0',
                    display:leftTreeToggleMenuBtn?'block':'none'}" size="small"></Button>
                <div :style="{textAlign:'center',display:treeDisp?'block':'none'}">
                    <br />
                    <CitySelector ref="cityselector" @on-city-changed="onCityChanged" @autoLocation="firstLocation" />
                </div>
            </Sider>
            <Layout>
                <Content class="content">
                    <div id="dividerDesc1"></div>
                    <div style="background:#FFFFFF;padding-left: 5px;">
                    </div>
                    <CityTable class="jd-table-overflow" v-if="showTable" ref="cityTbale1" id="topCom"></CityTable>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>
<script>
import City from '../common/aside/city2.vue'
import CityTable from '../search_engine/local/citytable.vue'
import AsideMenuCache from '../aside_menu_cache.vue'
//import RoadMap from '../road_map.vue'
// import SearchEngine from '../common/common_engine/user_search_list.vue'
import eventBus from "../common/event_bus.js"
import store from '../../store/'
export default {
    inject: ["setJdSearchIndex"],
    data() {
        return {
            rid: +new Date(),
            treeDisp: true,
            leftTreeToggleMenuBtn: true,
            isCollapsed: false,
            showTable:false,
            searchParams:{

            },
        }
    },
    provide() {
        return {
            parentSearchParams: this.searchParams,
        }
    },
    components: {
        // 'SearchEngine': SearchEngine,
        'FullTree': AsideMenuCache,
        //'MyRoadMap': RoadMap,
        'CitySelector': City,
        'CityTable': CityTable,
    },
    created() {
        store.state.user.initData.currentVersion = '2'
        this.setJdSearchIndex()
        //this.$refs.myAsideMenu.init()
    },
    mounted() {
        eventBus.$on('user-refresh-searchengine', () => {
            //this.reloadSearch()
        })

    },
    beforeDestroy() {
        eventBus.$off('user-refresh-searchengine')
    },
    methods: {
        firstLocation(value){
            var data={
                city:value
            }
            var params = {}
            if (data.city.length === 1) {
                params.province = data.city[0]
                params.city = []

            } else if (data.city.length === 2) {
                params.province = data.city[0]
                params.city = data.city[1]
            }
            params.country = "中央"
            params.classid = '' 
            this.searchParams=params
            this.showTable=true
            console.log('this.searchParams====>')
            console.log(this.searchParams)
             this.$nextTick(() => {
                 this.$refs.cityTbale1.jd_CitySelected(this.searchParams,'answer')
            })
           
        },
        scrollIntoViewResult1() {
            var element = document.getElementById("topCom");
            element.scrollIntoView();
        },
        showLocalView() {
            //this.$refs.cityTbale1.value1 = "1"
            this.scrollIntoViewResult1()
        },
        onCityChanged(value) {
            console.log(value)
            let parmars={
                city:value,
            }
            this.citySearch(parmars)

        },
        toggle() {
            this.$refs.lSider1.toggleCollapse()
        },
        changestate(state) {
            this.treeDisp = !state;
            store.commit('setLeftExpand', this.treeDisp)
        },
        search() {
            //this.$refs.searchlist.treeSelect('')
        },
        citySearch(data, iscity = true) {
            console.log("on-city-select===============>")
            this.showLocalView()
            console.log(data)
            //console.log(data.city.length)
            var params = {}
            if (data.city.length === 1) {
                params.province = data.city[0]
                params.city = []

            } else if (data.city.length === 2) {
                params.province = data.city[0]
                params.city = data.city[1]
            }
            params.country = "中央"
            params.classid = '' //data.classid
            this.searchParams = params
            // console.log('search_local_main...')
            // console.log(this)
            console.log(this.searchParams)
            //选择城市清除查询条件
            if (iscity) {
                this.$refs.cityTbale1.$refs.topSearchBar.resetCondition()
            }
            this.$refs.cityTbale1.getRegion(this.searchParams,'answer')
        },
        // reloadSearch() {
        //     //更换key以重置组件
        //     this.rid = +new Date()
        //     //this.$refs.searchlist.classid=''
        //     this.$refs.searchlist.treeSelect()
        // },
        // onMainSearch() {
        //     this.scrollIntoViewResult()
        // },
        // scrollIntoViewResult() {
        //     var element = document.getElementById("dividerDesc1");
        //     element.scrollIntoView();
        // },
        // flashMap(maps) {
        //     this.$refs.myroad.listen(maps);
        // },
        // showmap(maps, tabValue, cityValue) {
        //     console.log(maps, tabValue)
        //     var id = "";
        //     var selectNode = null
        //     var len
        //     if (maps !== undefined && maps.length > 0) {
        //         len = maps.length
        //     }
        //     if (maps[len - 1].node !== null) {
        //         selectNode = maps[len - 1].node
        //         id = selectNode.value
        //     }
        //     console.log("showmap id:" + id)
        //     this.$refs.myroad.listen(maps);
        //     this.$refs.searchlist.treeSelect(id)
        // },
    },
}
</script>
<style lang="less" scoped>
.sidebar {
    background: #fff;
    overflow: auto;
    transition: width .2s ease .2s; //无过度动画
    // Height: 81.8vh;
    height:88vh;
}

.content {
    padding: 0 0 0 10px;
    background: #F7F9FA;
}
.jd-table-overflow{
    height: 78.8vh;
    // overflow-y: auto;
}
</style>